var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.reports,"loading":_vm.status.loading,"items-per-page":50},on:{"click:row":_vm.clickedRow},scopedSlots:_vm._u([{key:"item.tempo",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"outlined":""}},[_vm._v(_vm._s(_vm.getTempo(item.tempo)))])]}},{key:"item.createdAt",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.humanDate(item.createdAt, "dd MMM yyyy - HH:mm"))+" ")]}},{key:"item.lastSent",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.humanDate(item.lastSent, "dd MMM yyyy - HH:mm"))+" ")]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }